module.exports = __webpack_public_path__ + "static/media/2.e02772d3.png";